/*
  Bildslider auf den Produktkarten der PLP (07.09.2026).

  Das Blaettern selbst macht CSS: .card__slider ist ein waagerechter
  Scrollbereich mit scroll-snap. Mobil wischt man also ohne JavaScript.
  Dieses Skript ergaenzt nur drei Dinge, die CSS nicht kann:

  1. PFEILE fuer Maus-Nutzer. Ein Trackpad wischt waagerecht, eine Maus nicht.
  2. PFEILE AUSBLENDEN am Anfang/Ende und den aktiven PUNKT mitfuehren.
  3. WISCHEN VOM KLICKEN TRENNEN - der wichtigste Teil. Die Bildspur liegt in
     einem <a> zur Produktseite. Ohne Gegenmassnahme fuehrt jedes Ziehen mit
     der Maus am Ende zu einem Klick und damit zum Seitenwechsel. Gemessen
     wird die zurueckgelegte Strecke ab pointerdown; ab 8px gilt es als Wischen
     und der darauffolgende Klick wird abgefangen.

  Bewusst KEIN Swiper: Die Bibliothek wuerde die Spur umbauen und Klone
  anlegen. Natives Scrollen ist hier leichter, ruckelt nicht und funktioniert
  auch, wenn das Skript gar nicht laedt - dann bleibt die Spur wischbar, nur
  ohne Pfeile.
*/
(function () {
  var ZIEH_SCHWELLE = 8;

  function init(karte) {
    if (karte.dataset.sliderBereit) return;
    karte.dataset.sliderBereit = '1';

    var spur = karte.querySelector('[data-card-slider]');
    if (!spur) return;
    // Die Zahl der Bilder kommt aus der SPUR, nicht aus der Zahl der Punkte.
    // Die Punkte sind ab 900px per CSS ausgeblendet, im Markup aber immer da -
    // haenge man die Zaehlung an sie, braeche sie, sobald jemand sie entfernt.
    var anzahl = spur.children.length;
    var punkte = karte.querySelectorAll('.card__slider-dot');
    var zurueck = karte.querySelector('.card__slider-arrow--prev');
    var weiter = karte.querySelector('.card__slider-arrow--next');

    function breite() {
      var b = spur.firstElementChild ? spur.firstElementChild.offsetWidth : spur.clientWidth;
      return b || spur.clientWidth;
    }
    function aktuellerIndex() {
      var b = breite();
      return b ? Math.round(spur.scrollLeft / b) : 0;
    }
    // Pfeile am Anfang bzw. Ende ausblenden, damit man nicht ins Leere tippt,
    // und den aktiven Punkt mitfuehren.
    function standSetzen() {
      var i = aktuellerIndex();
      if (zurueck) zurueck.hidden = i <= 0;
      if (weiter) weiter.hidden = i >= anzahl - 1;
      for (var k = 0; k < punkte.length; k++) {
        punkte[k].classList.toggle('is-active', k === i);
      }
    }
    function springe(richtung) {
      spur.scrollBy({ left: richtung * breite(), behavior: 'smooth' });
    }

    spur.addEventListener('scroll', standSetzen, { passive: true });
    if (zurueck) zurueck.addEventListener('click', function (e) { e.preventDefault(); springe(-1); });
    if (weiter) weiter.addEventListener('click', function (e) { e.preventDefault(); springe(1); });

    // Wischen vom Klicken trennen
    var startX = 0, startY = 0, gezogen = false;
    spur.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; gezogen = false;
    });
    spur.addEventListener('pointermove', function (e) {
      if (!e.buttons) return;
      if (Math.abs(e.clientX - startX) > ZIEH_SCHWELLE ||
          Math.abs(e.clientY - startY) > ZIEH_SCHWELLE) gezogen = true;
    });
    // In der ERFASSUNGSPHASE, damit der Klick den Link gar nicht erst erreicht.
    spur.addEventListener('click', function (e) {
      if (gezogen) { e.preventDefault(); e.stopPropagation(); gezogen = false; }
    }, true);

    standSetzen();
  }

  function alle() {
    var karten = document.querySelectorAll('.card__picture-container--slider');
    for (var i = 0; i < karten.length; i++) init(karten[i]);
  }

  document.addEventListener('DOMContentLoaded', alle);
  alle();
  // Filter und Blaettern tauschen das Raster aus, ohne die Seite neu zu laden -
  // deshalb neu einlesen, wenn Karten dazukommen.
  if (window.MutationObserver) {
    new MutationObserver(alle).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
